import getApiBase from "./apiBase";

const API_BASE = getApiBase();

const isAbsoluteUrl = (url) => /^https?:\/\//i.test(url);

export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (isAbsoluteUrl(url)) return url;
  if (
    url.startsWith("/images/uploads/")
    || url.startsWith("/images/customizer/artworks/")
    || url.startsWith("/images/customizer/previews/")
  ) {
    return `${API_BASE}${url}`;
  }
  return url;
};
